import { graphql } from "react-relay";

export const UpsertGCPIntegrationMutation = graphql`
  mutation UpsertGCPIntegrationMutation(
    $input: UpsertGCPIntegrationInput!
    $connections: [ID!]!
  ) {
    upsertGCPIntegration(input: $input) {
      gcpIntegration
        @appendNode(
          connections: $connections
          edgeTypeName: "GCPIntegrationEdge"
        ) {
        accessConfig {
          costSources {
            billingTable
          }
          infrastructure {
            projectId
          }
          organizations {
            folders {
              id
            }
            id
            name
            projects {
              id
            }
          }
          roundtripDigest
          securityContexts {
            extraRoles
            name
          }
        }
        customerConfig {
          costSources {
            billingTable
          }
          infrastructure {
            createProject {
              billingAccountId
              folderId
              labels {
                key
                value
              }
              orgId
            }
            projectId
            resourceLocation
            resourcePrefix
          }
          organizations {
            folderIds
            orgId
            projectIds
          }
          securityContexts {
            extraRoles
            name
          }
          terraformModule {
            blockHCL
            roundtripDigest
          }
        }
        key
      }
      problems {
        ... on Problem {
          message
        }
      }
    }
  }
`;
